import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import "./style.css";
import { useHistory, useLocation } from "react-router-dom";
import { ShimmerThumbnail } from "react-shimmer-effects";
import baseUrlNew from "../BaseUrl/index";
import axios from "axios";
import {
  getcardetailist,
  setChecklistSelections,
  img_list_action,
} from "../Redux/reduxflow/action";
import InputTypes from "../InputTypes";
import Camra from "../camera_question";
import { ToastContainer, toast } from "react-toastify";
import InspectionShell from "../components/InspectionShell";
import { BiRightArrowAlt } from "react-icons/bi";
import { HiChevronLeft } from "react-icons/hi";
import {
  buildAnswersFromSelections,
  fetchInspectionCarRow,
  findChecklistSection,
  toProductId,
  toSignedCarId,
} from "../utils/checklistAnswers";
import { sanitizeImageUrl } from "../utils/sanitizeImageUrl";

function hydrateSelections(questions, selectedSection) {
  const divindex = {};
  const pics = {};
  if (!Array.isArray(questions) || !selectedSection) {
    return { divindex, pics };
  }

  const savedQuestions =
    selectedSection.inspection_title ||
    selectedSection.questions ||
    [];
  if (!Array.isArray(savedQuestions) || !savedQuestions.length) {
    return { divindex, pics };
  }

  const byQuestionId = {};
  savedQuestions.forEach((q) => {
    if (q?.id != null) byQuestionId[q.id] = q;
  });

  questions.forEach((question, index) => {
    const saved = byQuestionId[question.id];
    if (!saved) return;

    const selected =
      saved.selected_inspection_question?.[0] ||
      saved.selected_inspection_question ||
      saved.selected ||
      null;
    if (!selected) return;

    const label =
      selected.choice_select_ ||
      selected.choice_select ||
      selected.choice ||
      "";
    const choiceId =
      selected.choice_select_id ||
      selected.choice_id ||
      selected.choice_select;

    let choice = null;
    if (choiceId != null && choiceId !== "") {
      choice = (question.choices || []).find(
        (c) => String(c.id) === String(choiceId)
      );
    }
    if (!choice && label) {
      choice = (question.choices || []).find(
        (c) => String(c.choice).trim() === String(label).trim()
      );
    }
    if (choice) {
      divindex[index] = choice.id;
    }

    const images = selected.images_ || saved.images_ || [];
    if (Array.isArray(images) && images.length) {
      pics[index] = images
        .map((img) =>
          sanitizeImageUrl(
            typeof img === "string" ? img : img?.url || img?.image || ""
          )
        )
        .filter(Boolean);
    }
  });

  return { divindex, pics };
}

export const CarUpdate = ({
  car_data,
  getcardetailist,
  setChecklistSelections,
  img_list_action,
  carquestionloading,
  divindex,
  pics,
}) => {
  const location = useLocation();
  const id = location.state.id;
  const car_id = location.state.car_id;
  const carName = location.state?.car_name || "Vehicle";
  const stepName = location.state?.step_name || "Checklist";

  useEffect(() => {
    GetCar_detail();
  }, []);

  const history = useHistory();
  const baseUrl = `${baseUrlNew.baseUrl}api/v1/getoption_inspection/`;

  const GetCar_detail = () => {
    // Reset only for this section load, then restore saved answers.
    setChecklistSelections({ divindex: {}, pics: {} });

    axios
      .post(baseUrl, {
        id: id,
      })
      .then(async (response) => {
        if (response.data.data.inspection_title.length > 0) {
          const questions = response.data.data.inspection_title;
          let hydrated = { divindex: {}, pics: {} };

          // 1) Preferred: getselected_inspection (has choice + images).
          try {
            const selectedRes = await axios.post(
              `${baseUrlNew.baseUrl}api/v1/getselected_inspection/`,
              { id: toProductId(car_id) }
            );
            const sections = selectedRes?.data?.data?.data || [];
            const section =
              sections.find((s) => String(s.id) === String(id)) || null;
            hydrated = hydrateSelections(questions, section);
          } catch {
            /* try inspection_cars next */
          }

          // 2) Fallback: inspection_cars row / navigation state.
          if (!Object.keys(hydrated.divindex || {}).length) {
            try {
              const car =
                location.state?.inspectionCar ||
                (await fetchInspectionCarRow(car_id));
              const section = findChecklistSection(car, id, stepName);
              hydrated = hydrateSelections(questions, section);
            } catch {
              hydrated = { divindex: {}, pics: {} };
            }
          }

          setChecklistSelections(hydrated);
          getcardetailist(response.data);
        } else {
          setChecklistSelections({ divindex: {}, pics: {} });
          toast(
            `No inspection questions are available for ${
              response.data.data.title || stepName
            }.`
          );
          history.replace({
            pathname: "/inspection/carsteps",
            state: {
              id: car_id,
              car_name: carName,
              inspect: location.state?.inspect,
              report: location.state?.report,
              inspectionCar: location.state?.inspectionCar,
              stepsGroup: "checklist",
            },
          });
        }
      });
  };

  const baseUrl2 = `${baseUrlNew.baseUrl}api/v1/create_selected_options/`;

  const [index, setIndex] = useState(0);
  const [showCam, setShowCam] = useState(false);
  const [saving, setSaving] = useState(false);
  const picsRef = useRef(pics || {});

  useEffect(() => {
    picsRef.current = pics || {};
  }, [pics]);

  const showCamFunction = (camOn) => {
    setShowCam(!!camOn);
  };

  const openChecklistCamera = () => {
    setShowCam(true);
  };

  const questions = Array.isArray(car_data) ? car_data : [];
  const answeredCount = questions.reduce((count, _, i) => {
    const value = divindex?.[i];
    return count + (value !== undefined && value !== null && value !== "" ? 1 : 0);
  }, 0);
  const progressPct = questions.length
    ? Math.min(100, Math.round((answeredCount / questions.length) * 100))
    : 0;
  const headerBadge = questions.length
    ? `Checklist · Q${index + 1}/${questions.length}`
    : "Checklist";

  const goSteps = (answersPatch) => {
    history.push({
      pathname: "/inspection/carsteps",
      state: {
        id: car_id,
        car_name: carName,
        inspect: location.state?.inspect,
        report: location.state?.report,
        inspectionCar: location.state?.inspectionCar,
        stepsGroup: "checklist",
        checklistAnswersPatch: answersPatch || undefined,
      },
    });
  };

  const persistCurrentAnswers = () => {
    const answers = buildAnswersFromSelections(questions, divindex);
    return { [id]: answers };
  };

  /** Persist current question answer + photos. Pass imagesOverride right after capture (Redux may be stale). */
  const carfeatureadd = async (imagesOverride) => {
    if (!questions[index]) return false;
    const choice = divindex[index];
    if (choice === undefined || choice === null || choice === "") {
      return false;
    }
    const signedCar = toSignedCarId(car_id);
    if (!signedCar) {
      toast.error("Missing vehicle id. Go back and open this car again.");
      return false;
    }
    const images =
      imagesOverride !== undefined
        ? imagesOverride
        : picsRef.current?.[index] || pics?.[index] || [];
    setSaving(true);
    try {
      const response = await axios.post(baseUrl2, {
        // API decode_sign(Car) — must be the signed token from inspection_cars.
        Car: signedCar,
        question_select: questions[index]["id"],
        choice_select: choice,
        images_s: images,
      });
      const savedImages = response?.data?.data?.images;
      if (Array.isArray(images) && images.length && Array.isArray(savedImages) && !savedImages.length) {
        toast.warn("Answer saved, but the server did not keep the photo.");
      }
      return true;
    } catch (err) {
      toast.error(
        err?.response?.status === 500
          ? "Server error while saving this answer."
          : "Could not save this answer. Please try again."
      );
      return false;
    } finally {
      setSaving(false);
    }
  };

  const saveChecklistPic = async (data) => {
    const url = data?.url;
    if (!url) return;
    const nextImages = [...(picsRef.current?.[index] || []), url];
    picsRef.current = { ...picsRef.current, [index]: nextImages };
    img_list_action({
      imges: url,
      index,
    });
    const choice = divindex[index];
    if (choice === undefined || choice === null || choice === "") {
      toast.info("Photo added. Select an answer, then tap Next/Done to save.");
      return;
    }
    const ok = await carfeatureadd(nextImages);
    if (ok) {
      toast.success("Photo saved to this answer.");
    }
  };

  const leaveSection = async () => {
    await carfeatureadd();
    goSteps(persistCurrentAnswers());
  };

  const doneinput = async () => {
    const ok = await carfeatureadd();
    if (!ok && (picsRef.current?.[index] || []).length) {
      toast.error("Could not save photos. Stay on this question and try Done again.");
      return;
    }
    goSteps(persistCurrentAnswers());
  };

  const nextSlide = async () => {
    await carfeatureadd();
    if (index < questions.length - 1) {
      setIndex((i) => i + 1);
    }
  };

  const prevSlide = async () => {
    if (index > 0) {
      await carfeatureadd();
      setIndex((i) => i - 1);
    } else {
      await leaveSection();
    }
  };

  const footerNav =
    !showCam && !carquestionloading ? (
      <div className="pi-check__footer">
        <div className="pi-check__footer-inner">
          <p className="pi-check__footer-meta">
            <strong>
              {answeredCount}/{questions.length || 0}
            </strong>
            <span>answered</span>
          </p>
          <div className="pi-check__footer-actions">
            <button
              type="button"
              className="pi-check__btn pi-check__btn--ghost"
              onClick={prevSlide}
              disabled={saving}
            >
              <HiChevronLeft size={18} aria-hidden />
              {index > 0 ? "Previous" : "Back"}
            </button>
            {index < questions.length - 1 ? (
              <button
                type="button"
                className="pi-check__btn pi-check__btn--primary"
                onClick={nextSlide}
                disabled={saving}
              >
                {saving ? "Saving…" : "Next"}
                {!saving ? <BiRightArrowAlt size={18} aria-hidden /> : null}
              </button>
            ) : (
              <button
                type="button"
                className="pi-check__btn pi-check__btn--primary"
                onClick={doneinput}
                disabled={saving}
              >
                {saving ? "Saving…" : "Done"}
                {!saving ? <BiRightArrowAlt size={18} aria-hidden /> : null}
              </button>
            )}
          </div>
        </div>
      </div>
    ) : null;

  const questionPanel = questions[index] ? (
    <InputTypes
      data={questions[index]}
      index_of={index}
      showCamFunction={showCamFunction}
      onAddPhoto={openChecklistCamera}
    />
  ) : null;

  // Camera / desktop alert — no checklist shell (same as damage capture).
  if (showCam) {
    return (
      <>
        <Camra
          save_pics={saveChecklistPic}
          setshowcamra={setShowCam}
          desktopTitle={stepName}
          desktopBadge={headerBadge}
          desktopLabel="Checklist photo"
        />
        <ToastContainer />
      </>
    );
  }

  return (
    <InspectionShell
      badge={headerBadge}
      title={stepName}
      onBack={leaveSection}
      mainClassName="pi-inspection-main--dashboard"
      className="pi-inspection-page--app"
      showFooter={false}
      bottomNav={footerNav}
    >
      <div className="pi-check">
        <header className="pi-check__hero">
          <div className="pi-check__hero-copy">
            <p className="pi-inspection-label">Checklist section</p>
            <h1>{stepName}</h1>
            <p>
              {carName} · Question {questions.length ? index + 1 : 0} of{" "}
              {questions.length || 0}
            </p>
          </div>
          <div className="pi-check__progress">
            <div className="pi-check__progress-label">
              <span>
                {answeredCount} of {questions.length || 0} answered
              </span>
              <em>{progressPct}%</em>
            </div>
            <div className="pi-check__track" aria-hidden>
              <span style={{ width: `${progressPct}%` }} />
            </div>
            {questions.length > 0 ? (
              <div
                className="pi-check__steps"
                aria-label={`Question ${index + 1} of ${questions.length}`}
              >
                {questions.map((_, i) => {
                  const answered =
                    divindex?.[i] !== undefined &&
                    divindex?.[i] !== null &&
                    divindex?.[i] !== "";
                  return (
                    <span
                      key={`step-${i}`}
                      className={`pi-check__step${
                        i === index ? " is-current" : ""
                      }${answered ? " is-done" : ""}`}
                    />
                  );
                })}
              </div>
            ) : null}
          </div>
        </header>

        {carquestionloading ? (
          <div className="pi-check__loading">
            <ShimmerThumbnail height={160} rounded />
            <ShimmerThumbnail height={60} rounded />
            <ShimmerThumbnail height={60} rounded />
          </div>
        ) : (
          questionPanel
        )}
      </div>
      <ToastContainer />
    </InspectionShell>
  );
};

const mapStateToProps = (state) => ({
  car_data: state.cardata.data.inspection_title,
  carquestionloading: state.cardata.carquestionloading,
  divindex: state.cardata.divindex,
  userinfo: state.cardata.userinfo,
  pics: state.cardata.pics,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getcardetailist: (response) => dispatch(getcardetailist(response)),
    setChecklistSelections: (payload) =>
      dispatch(setChecklistSelections(payload)),
    img_list_action: (response) => dispatch(img_list_action(response)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CarUpdate);
